import GetRedebitsListRequestModelBase from '../_generated/modelBases/get-redebits-list-request-model-base';

export default class GetRedebitsListRequestModel extends GetRedebitsListRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
